<template>
  <div class="grid-standard gap-16" data-test="product-card-grid">
    <div
      v-for="(product, index) in products"
      :key="product.title"
      :ref="setupViewportTrackingProduct(product, tracking)"
      class="md:col-span-2 lg:col-span-3"
    >
      <ProductCardCarouselCard
        :index
        :product
        :product-granularity
        :tracking
        v-on="addToCartListener ? { addToCart: handleAddToCart(product) } : {}"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { getCurrentInstance } from 'vue'

import type { ProductGranularity } from '@backmarket/http-api/src/api-specs-content/shared/product-granularity'

import {
  type ExtraTrackingData,
  useImpressionTracking,
} from '../../composables/useProductTracking'
import type { Product, Products } from '../../models/product'

import ProductCardCarouselCard from './ProductCardCarouselCard.vue'

withDefaults(
  defineProps<{
    products: Products
    tracking: ExtraTrackingData
    productGranularity?: ProductGranularity
  }>(),
  {
    productGranularity: undefined,
  },
)

const emits = defineEmits<{
  (e: 'add-to-cart', data: { status: string; product: Product }): void
}>()

const addToCartListener = getCurrentInstance()?.vnode.props?.onAddToCart

function handleAddToCart(product: Product) {
  return ({ status }: { status: string }) => {
    emits('add-to-cart', { status, product })
  }
}

const { setupViewportTrackingProduct } = useImpressionTracking()
</script>
